import { Episode, EpisodeStates } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'
import { ProgramNames } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'

import { getProviderEpisodes } from '../../../episodes/data/episodeParticipants'

type GetEpisodesForDetailsPanelArgs = {
  episodes: Episode[]
  currentEpisode?: Episode
  providerId: string
  isDBTTeensEnabled: boolean
  openClientAccessSupported: boolean
}

/**
 * Client details are normally derived from episodes owned by the current provider. DBT Teens providers can also open
 * an active DBT Teens episode before they are associated with it, so include that episode when the role has open-client
 * access, preferring the current selection when it is available. This lets the existing caregiver resolver use the
 * episode's participants and intake assignment.
 */
export const getEpisodesForDetailsPanel = ({
  episodes,
  currentEpisode,
  providerId,
  isDBTTeensEnabled,
  openClientAccessSupported,
}: GetEpisodesForDetailsPanelArgs): Episode[] => {
  const providerEpisodes = getProviderEpisodes(episodes, providerId)
  const openClientEpisode =
    openClientAccessSupported && isDBTTeensEnabled
      ? [currentEpisode, ...episodes].find(
          (episode) =>
            episode?.provider_id !== providerId &&
            episode?.state === EpisodeStates.IN_PROGRESS &&
            episode?.program_name === ProgramNames.DialecticalBehaviorTherapyTeens,
        )
      : undefined

  return openClientEpisode ? [openClientEpisode, ...providerEpisodes] : providerEpisodes
}
